<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <!--<li><router-link to="/modules/reviewerdocuments/edit">{{lang.LBL_ADD_BUDGETHEAD}}</router-link></li>
        <li><router-link to="/modules/reviewerdocuments">{{lang.LBL_VIEW_BUDGETHEAD}}</router-link></li>!-->
    </ul>
</template>
<script>
import lang from "@/views/modules/ReviewerDocuments/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
